import React from "react";
import Navbar from "./components/Navbar";
import "./HomePage.css";
import Footer from "./components/Footer";

function HomePage() {
  return (
    <div className="home-page">
      <Navbar currentPath="/" />

      {/* Hero Section */}
      <header className="hero">
        <div className="container">
          {/* <h1 className="hero-title">热茶满座</h1> */}
          <p className="hero-subtitle">思考，然后得到什么。</p>

          {/* 碰杯动画 */}
          <div className="cup-animation">
            {/* 左杯：杯口朝右 */}
            <svg className="cup cup-left" viewBox="0 0 32 32" fill="none">
              <path
                d="M6 8h16v14c0 2.21-1.79 4-4 4H10c-2.21 0-4-1.79-4-4V8z"
                // fill="#D4B896"
                fill="#c6c6c6"
                transform="scale(-1,1) translate(-32,0)"
              />
              {/* <path d="M6 8h4v2H6z" fill="#A67B5B" />
              <path d="M6 10h-2v10c0 1.657 1.343 3 3 3h2V10z" fill="#E8DCC5" />
              <ellipse cx="18" cy="8" rx="10" ry="2" fill="#C9A77C" /> */}
              <path d="M6 8h4v2H6z" fill="#01050b" />
              <path d="M6 10h-2v10c0 1.657 1.343 3 3 3h2V10z" fill="#8a8b91" />
              <ellipse cx="18" cy="8" rx="10" ry="2" fill="#908d8d" />
            </svg>

            {/* 右杯：杯口朝左 */}
            <svg className="cup cup-right" viewBox="0 0 32 32" fill="none">
              <path
                d="M6 8h16v14c0 2.21-1.79 4-4 4H10c-2.21 0-4-1.79-4-4V8z"
                fill="#c6c6c6"
              />
              <path d="M22 8h4v2h-4z" fill="#01050b" />
              <path
                d="M26 10h2v10c0 1.657-1.343 3-3 3h-2v-13z"
                fill="#8a8b91"
              />
              <ellipse cx="14" cy="8" rx="10" ry="2" fill="#908d8d" />
            </svg>

            {/* 热气 */}
            <div className="steam-container">
              <div className="steam steam-left-1"></div>
              <div className="steam steam-left-2"></div>
              <div className="steam steam-left-3"></div>
              <div className="steam steam-right-1"></div>
              <div className="steam steam-right-2"></div>
              <div className="steam steam-right-3"></div>
            </div>
          </div>

          {/* 按钮 */}
          {/* <a href="/app" className="btn btn-primary hero-btn">
            探索
          </a> */}
        </div>
      </header>

      {/* Footer */}
      <Footer />
      {/* <footer className="footer">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} 热茶满座. All Rights Reserved.
          </p>
        </div>
      </footer> */}
    </div>
  );
}

export default HomePage;
